import { Link, useLocation } from 'react-router-dom';
import Button from '@/components/Button';
import dondonIcon from '@/assets/dondon_white.svg';
import footerBgIcon from '@/assets/footer_bg.png';
import footerDondonIcon from '@/assets/footer_dondon.svg';
import { useTranslation } from 'react-i18next';
import useAuthStore from '@/stores/authStore';

const Footer = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const accessToken = useAuthStore((state) => state.accessToken);

  // Only show reminder on these pages
  const showReminderPages = ['/', '/card'];
  const shouldShowReminder = !accessToken && (
    showReminderPages.includes(pathname) || 
    pathname.startsWith('/card/')
  );

  return (
    <div className="w-full">
      {shouldShowReminder && (
        <div className="w-full">
          <div className="relative">
            <div className="w-full h-[278px] flex justify-center items-center overflow-hidden">
              <img src={footerBgIcon} className='w-full h-full object-cover' />
            </div>

            <div className="absolute inset-0 flex items-center justify-center">
              <img src={footerDondonIcon} />
            </div>

            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-white mb-4">
                  {t('footer.reminder.line1')}
                </h3>
                <p className="text-white mb-6">
                  {t('footer.reminder.line2')}
                </p>
                <div>
                  <Link to="/introduction/pc">
                    <Button variant="primary" size="m" className="bg-transparent border border-white mr-4 w-32">
                      {t('footer.reminder.more')}
                    </Button>
                  </Link>
                  <Link to="/signup">
                    <Button variant="default" size="m" className="w-32">
                      {t('footer.reminder.register')}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-[#111111] border-t border-white">
        <div className="self-stretch px-[100px] py-10 flex justify-between items-center gap-x-20">
          <div className="pt-5 flex justify-start items-center gap-4">
            <img src={dondonIcon} alt="Logo" className="w-[256px]" />
          </div>
          
          <div className="grid grid-cols-3 grid-rows-5 gap-x-[50px] gap-y-2.5">
            <Link to="/introduction/pc" className="text-white text-base hover:text-gray-300">{t('footer.first_time_users')}</Link>
            <Link to="/terms/guideline_listing" className="text-white text-base hover:text-gray-300">{t('footer.listing_guidelines')}</Link>
            <Link to="/terms/terms_of_use" className="text-white text-base hover:text-gray-300">{t('footer.terms')}</Link>
            
            <Link to="/terms/fees_charges" className="text-white text-base hover:text-gray-300">{t('footer.fees_shipping')}</Link>
            <Link to="/terms/guideline_photo" className="text-white text-base hover:text-gray-300">{t('footer.photo_guidelines')}</Link>
            <Link to="/terms/privacy_policy" className="text-white text-base hover:text-gray-300">{t('footer.privacy_policy')}</Link>
            
            <Link to="/terms/sale_transfer" className="text-white text-base hover:text-gray-300">{t('footer.sales_payouts')}</Link>
            <Link to="/terms/guideline_packing_shipping" className="text-white text-base hover:text-gray-300">{t('footer.pack_guidelines')}</Link>
            <Link to="/terms/external_transmission_policy" className="text-white text-base hover:text-gray-300">{t('footer.data_sharing_policy')}</Link>
            
            <Link to="/terms/payment_methods" className="text-white text-base hover:text-gray-300">{t('footer.payments_coupons')}</Link>
            <Link to="/terms/guideline_transaction" className="text-white text-base hover:text-gray-300">{t('footer.transaction_flow')}</Link>
            <Link to="/terms/commercial_transaction_info" className="text-white text-base hover:text-gray-300">{t('footer.commercial_law')}</Link>
            
            <Link to="/terms/compensation" className="text-white text-base hover:text-gray-300">{t('footer.buyer_protection')}</Link>
            <Link to="/terms/faq_packing_shipping" className="text-white text-base hover:text-gray-300">{t('footer.faq')}</Link>
            <a href="https://www.iva-corp.com/" target="_blank" rel="noopener noreferrer" className="text-white text-base hover:text-gray-300">{t('footer.company_info')}</a>
          </div>
        </div>
        
        <div className="self-stretch py-[5px] bg-[#222222] flex justify-center items-center gap-2.5">
          <div className="text-white text-base">{t('footer.copyright')}</div>
        </div>
      </div>
    </div>
  );
};

export default Footer; 